export default __webpack_public_path__ + "static/tasa-nominal-4b0977bde6e680e66435e74e1da30d78.png";